// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .value--3kI03 {\n  margin-left: 30px;\n}[dir=rtl] .value--3kI03 {\n  margin-right: 30px;\n}\n", ""]);
// Exports
exports.locals = {
	"value": "value--3kI03"
};
module.exports = exports;
